var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseSm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons Outline/Action/close-sm"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1589 6.841C17.5104 7.19247 17.5104 7.76232 17.1589 8.11379L13.2728 11.9999L17.1589 15.886C17.5104 16.2374 17.5104 16.8073 17.1589 17.1588C16.8074 17.5102 16.2376 17.5102 15.8861 17.1588L12 13.2727L8.11403 17.1587C7.76256 17.5101 7.19271 17.5101 6.84124 17.1587C6.48977 16.8072 6.48977 16.2373 6.84124 15.8859L10.7272 11.9999L6.84124 8.1139C6.48977 7.76242 6.48977 7.19258 6.84124 6.8411C7.19271 6.48963 7.76256 6.48963 8.11403 6.8411L12 10.7271L15.8861 6.841C16.2376 6.48952 16.8074 6.48952 17.1589 6.841Z",
    fill: "#C7CDD6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSm);
export default __webpack_public_path__ + "static/media/close-sm.832ae54a5f672d527dfe8482faf0a0b9.svg";
export { ForwardRef as ReactComponent };